<template>
    <div class="login-page">
        <v-alert
            v-if="showClockInError"
            class="mx-16"
            style="justify-content: center; margin-top: 16px"
            type="error"
            title="Please punch within 7 minutes of your Shift!"
            text="Regístrese dentro de los 7 minutos antes del comienzo de su turno!"
        ></v-alert>
        <v-alert
            v-if="showEpicorError"
            class="mx-16"
            style="justify-content: center; margin-top: 16px"
            type="error"
            title="Error!"
            :text="errorMessage"
        ></v-alert>
        <v-progress-linear
            :model-value="remainingTime * 10"
            height="10"
            striped
            color="cyan"
        ></v-progress-linear>

        <v-row class="center-container" justify="center">
            <v-col cols="12" class="digital-calander">
                <span>{{ currentDate }}</span>
            </v-col>

            <v-col cols="12" class="digital-clock" style="margin-top: -30px">
                <span>{{ currentTime }}</span>
            </v-col>
        </v-row>

        <!---Info--->
        <v-row style="margin-top: -25px">
            <!-- Left side (v-text-fields) -->
            <v-col lg="4" md="4" sm="12" xs="12">
                <v-text-field
                    style="color: black"
                    v-model="employeeInfo.ID"
                    class="ms-3"
                    variant="solo-filled"
                    label="Employee ID"
                    readonly
                ></v-text-field>

                <v-text-field
                    v-model="employeeInfo.Name"
                    style="color: black"
                    variant="solo-filled"
                    label="Name"
                    class="ms-3"
                    readonly
                ></v-text-field>

                <v-text-field
                    readonly
                    v-model="employeeInfo.Agency_c"
                    style="color: black"
                    variant="solo-filled"
                    label="Agency"
                    class="ms-3"
                ></v-text-field>

                <v-text-field
                    v-model="employeeInfo.Description"
                    style="color: black"
                    variant="solo-filled"
                    readonly
                    label="Shift"
                    class="ms-3"
                ></v-text-field>

                <!--                <v-text-field-->
                <!--                    readonly-->
                <!--                    style="color: black"-->
                <!--                    variant="solo-filled"-->
                <!--                    v-model="lastClockIn"-->
                <!--                    label="Last Clock In"-->
                <!--                    class="ms-3"-->
                <!--                ></v-text-field>-->
            </v-col>

            <!-- Right side (vueasy table) -->
            <v-col lg="7" md="7" sm="12" xs="12">
                <v-data-table
                    :headers="headers"
                    :items="tableData"
                    :items-per-page="-1"
                    fixed-header
                >
                    <!----HIDE FOOTER---->
                    <template #bottom></template>
                    <!------->

                    <template v-slot:item.PayrollDate="{ item }">
                        <div v-if="item.PayrollDate">
                            {{ momentJS(item.PayrollDate).format("MM-DD-YYYY") }}
                        </div>
                        <div v-else>-</div>
                    </template>
                    <template v-slot:item.DayOfWeek="{ item }">
                        <div v-if="item.PayrollDate">
                            {{ momentJS(item.PayrollDate).format("dddd") }}
                        </div>
                        <div v-else>-</div>
                    </template>
                    <template v-slot:item.ClockInTime="{ item }">
                        <div v-if="item.ClockInTime">
                            {{ formatTime(item.ClockInTime) }}
                        </div>
                        <div v-else>-</div>
                    </template>
                    <template v-slot:item.LunchOut="{ item }">

                        <div v-if="item.LunchOut && item.LunchOut != '.00'">
                            {{ formatTime(item.LunchOut) }}
                        </div>
                        <div v-else-if="item.LunchOut == '.00'">-</div>
                        <div v-else>-</div>
                    </template>
                    <template v-slot:item.LunchIn="{ item }">

                        <div v-if="item.LunchIn && item.LunchIn != '.00'">
                            {{ formatTime(item.LunchIn) }}
                        </div>
                        <div v-else-if="item.LunchIn == '.00'">-</div>
                        <div v-else>-</div>
                    </template>

                    <template v-slot:item.ClockOutTime="{ item }">

                        <div v-if="item.ClockOutTime && item.ClockOutTime != '24:00' && item.ClockOutTime != '24.00'">
                            {{ formatTime(item.ClockOutTime) }}
                        </div>
                        <div v-else-if="item.ClockOutTime == '24:00' || item.ClockOutTime == '24.00'">-</div>
                        <div v-else>-</div>
                    </template>
                </v-data-table>


            </v-col>
        </v-row>
        <v-alert
            class="mx-16"
            style="justify-content: center; margin-top: 16px"
            v-if="clockedInAlert"
            type="success"
            title="Successfully Clocked In!"
            text="You have successfully clocked in!"
        ></v-alert>

        <v-alert
            class="mx-16"
            style="justify-content: center; margin-top: 16px"
            v-if="clockedOutAlert"
            type="success"
            title="Successfully Clocked Out!"
            text="You have successfully clocked out!"
        ></v-alert>

        <v-alert
            class="mx-16"
            style="justify-content: center; margin-top: 16px"
            v-if="lunchOutAlert"
            type="success"
            title="Successfully Lunch Out!"
            text="You have successfully lunch out!"
        ></v-alert>

        <v-alert
            class="mx-16"
            style="justify-content: center; margin-top: 16px"
            v-if="lunchInAlert"
            type="success"
            title="Successfully Lunch In!"
            text="You have successfully lunch in!"
        ></v-alert>

        <v-row
            style="display: flex; justify-content: center"
            class="text-center"
            v-if="employeeInfo.Active == '0'"
        >
            <v-btn
                height="100"
                size="x-large"
                color="green"
                @click="clockIn"
                :loading="loadingClockIn"
            >
                <v-icon left style="margin-right: 10px">mdi:mdi-clock</v-icon>
                <h3>Clock In</h3>
                <span style="font-style: italic; margin-left: 10px"
                    >Marcar Entrar</span
                >
            </v-btn>
        </v-row>

        <v-row
            style="display: flex; justify-content: center; margin-top: 40px"
            class="text-center"
            v-if="employeeInfo.Active == '1'"
        >
            <v-btn
                height="100"
                size="x-large"
                color="yellow"
                @click="lunchOut"
                :loading="loadingLunchOut"
                v-if="
                    employeeInfo.LunchStatus == 'N' &&
                    employeeInfo.LunchStatus != 'C'
                "
            >
                <v-icon left style="margin-right: 10px">mdi:mdi-clock</v-icon>
                <h3>Go To Lunch</h3>
                <span style="font-style: italic; margin-left: 10px"
                    >Ir a almorzar</span
                >
            </v-btn>

            <v-btn
                height="100"
                size="x-large"
                style="margin-left: 30px"
                color="#64B5F6"
                @click="lunchIn"
                :loading="loadingLunchIn"
                v-if="
                    employeeInfo.LunchStatus == 'I' &&
                    employeeInfo.LunchStatus != 'C'
                "
            >
                <v-icon left style="margin-right: 10px">mdi:mdi-clock</v-icon>
                <h3>Return From Lunch</h3>
                <span style="font-style: italic; margin-left: 10px"
                    >Regreso del almuerzo</span
                >
            </v-btn>
        </v-row>

        <v-row
            style="display: flex; justify-content: center; margin-top: 30px"
            class="text-center"
            v-if="employeeInfo.Active == '1' || employeeInfo.Active == '2'"
        >
            <v-btn
                height="100"
                size="x-large"
                color="red"
                @click="clockOut"
                :loading="loadingClockOut"
            >
                <v-icon left style="margin-right: 10px">mdi:mdi-clock</v-icon>
                <h3>Clock Out</h3>
                <span style="font-style: italic; margin-left: 10px"
                    >Marcar Salida</span
                >
            </v-btn>
        </v-row>

        <v-row
            style="display: flex; justify-content: center; margin-top: 30px"
            class="text-center"
        >
            <v-btn size="x-large" @click="exitLoggedInPage">
                <v-icon left style="margin-right: 10px"
                    >mdi:mdi-keyboard-backspace
                </v-icon>
                <h3>Back</h3>
                <span style="font-style: italic; margin-left: 10px">Atras</span>
            </v-btn>
        </v-row>
    </div>
</template>
<script>
import moment from "moment";
import GuestLayout from "../../Layouts/GuestLayout.vue";
import { Link } from "@inertiajs/inertia-vue3";
import axios from "axios";

export default {
    props: {
        employeeInfo: Object, // Define the props to receive employee information
    },
    components: {
        Link,
    },
    layout: [GuestLayout],
    data: () => ({
        //employeeID: "",
        employeeData: [],
        lastClockIn: "",
        currentTime: "",
        currentDate: "",
        loadingClockIn: false,
        loadingLunchOut: false,
        loadingLunchIn: false,
        loadingClockOut: false,
        clockedInAlert: false,
        clockedOutAlert: false,
        lunchOutAlert: false,
        lunchInAlert: false,
        nameMarginTop: "-175px", // Default value
        showAlert: false,
        parallaxHeight: "100vh", // Set the initial height to 100% of the viewport height
        headers: [
            { title: "Date", key: "PayrollDate" },
            { title: "Day", key: "DayOfWeek" },
            { title: "Clock In", key: "ClockInTime" },
            { title: "Lunch Start", key: "LunchOut" },
            { title: "Lunch End", key: "LunchIn" },
            { title: "Clock Out", key: "ClockOutTime" },
        ],
        tableItems: [],
        remainingTime: 70,
        momentJS: null,
        showClockInError: false,
        errorMessage: "",
        showEpicorError: false,
        routePrefix: '',
    }),

    mounted() {
        this.routePrefix = this.$page.props.routePrefix || 'legacy-api.'; // Get the routePrefix from the page props
        this.updateTime();
        setInterval(this.updateTime, 1000); // Update time every second

        // Add an event listener to handle screen size changes
        window.addEventListener("resize", this.updateParallaxHeight);

        // Start the timer to exit the page after 50 seconds
        setInterval(this.updateTime, 1000);
        setInterval(this.updateRemainingTime, 1000); // Update Page remaining time every second
    },

    beforeUnmount() {
        // Remove the event listener to avoid memory leaks
        window.removeEventListener("resize", this.updateParallaxHeight);
    },

    created() {
        this.momentJS = moment;
    },

    watch: {},
    computed: {
        tableData() {
            const emptyRowCount = Math.max(
                7 - this.employeeInfo.tableItems.length,
                0
            );

            // Create an array of dummy data
            const dummyData = Array.from(
                { length: emptyRowCount },
                (_, index) => ({
                    id: index, // Add other dummy properties if needed
                    PayrollDate: null,
                })
            );

            return [...this.employeeInfo.tableItems, ...dummyData];
        },
    },
    methods: {
        formatDate(date) {
            return moment(date).format("MM/DD/YYYY");
        },

        formatTime(time) {
            var newFormat = moment.duration(time, "hours");
            newFormat = moment()
                .hour(newFormat.get("hours"))
                .minute(newFormat.get("minutes"));
            return moment(newFormat, ["HH:mm"]).format("hh:mm a");
        },
        formatTimeAPI(time) {
            var newFormat = moment.duration(time, "hours");
            newFormat = moment()
                .hour(newFormat.get("hours"))
                .minute(newFormat.get("minutes"));
            return moment(newFormat, ["HH:mm"]).format("HH:mm");
        },

        updateTime() {
            const now = new Date();
            this.currentTime = now.toLocaleTimeString();
            this.currentDate = now.toLocaleDateString();
        },

        updateParallaxHeight() {
            // Update the parallaxHeight based on the new viewport height
            this.parallaxHeight = window.innerHeight + "px";
        },

        onResize() {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight };
        },

        updateRemainingTime() {
            if (this.remainingTime > 0) {
                this.remainingTime -= 5;
                if (this.remainingTime === 0) {
                    // Time is up, exit the page or do any other required actions
                    this.exitLoggedInPage();
                }
            }
        },

        async clockIn() {
            this.loadingClockIn = true;
            this.remainingTime = 250;
            this.errorMessage = "";
            this.showEpicorError = false;
            const shiftStartTime = this.formatTimeAPI(
                this.employeeInfo.StartTime
            );
            const currentTime = moment().format("HH:mm");

            const targetMoment = moment(shiftStartTime, "HH:mm");
            const inputMoment = moment(currentTime, "HH:mm");

            const diffInMinutes = inputMoment.diff(targetMoment, "minutes");

            //diffInMinutes <= 4 * 60  or up to hours later ??
            //console.log(diffInMinutes, shiftStartTime, currentTime);
            if (diffInMinutes >= -7 || diffInMinutes >= 0) {
                try {
                    await axios
                        .post(
                            route(`${this.routePrefix}punch-clockIn`, {
                                empID: this.employeeInfo.ID,
                                Shift: this.employeeInfo.Shift,

                            })
                        )
                        .then((res) => {
                            if (res.data.Status === 0) {
                                this.showEpicorError = true;
                                this.errorMessage = res.data.Message;
                                setTimeout(() => {
                                    this.exitLoggedInPage();
                                }, 4000);
                            } else {
                                this.clockedInAlert = true;

                                setTimeout(() => {
                                    this.clockedInAlert = false;
                                    this.exitLoggedInPage();
                                }, 3000);
                            }
                        });
                } catch (err) {
                    console.error("Clock In Error:", err);
                }
            } else {
                this.showClockInError = true;
                this.loadingClockIn = false;
                setTimeout(() => {
                    this.showClockInError = false;
                    this.exitLoggedInPage();
                }, 3000);
            }
        },

        async clockOut() {
            this.loadingClockOut = true;
            this.remainingTime = 250;
            try {
                await axios
                    .post(
                        route(`${this.routePrefix}punch-clockOut`, {
                            empID: this.employeeInfo.ID,
                        })
                    )
                    .then((res) => {
                        if (res.data.Status === 0) {
                            this.showEpicorError = true;
                            this.errorMessage = res.data.Message;
                            setTimeout(() => {
                                this.exitLoggedInPage();
                            }, 5000);
                        } else {
                            this.clockedOutAlert = true;

                            setTimeout(() => {
                                this.clockedOutAlert = false;
                                this.exitLoggedInPage();
                            }, 3000);
                        }
                    });
            } catch (err) {
                console.error("Clock In Error:", err);
                this.loadingClockOut = false;
            }
        },

        async lunchOut() {
            this.loadingLunchOut = true;
            this.remainingTime = 250;
            try {
                const response = await axios.post(
                    route(`${this.routePrefix}punch-lunchClock`),
                    { empID: this.employeeInfo.ID }
                );

                this.lunchOutAlert = true;

                setTimeout(() => {
                    this.lunchOutAlert = false;
                    this.exitLoggedInPage();
                    //this.loadingLunchOut = false;
                }, 3000);
            } catch (err) {
                console.error("Clock In Error:", err);
                this.loadingLunchOut = false;
            }
        },

        async lunchIn() {
            this.loadingLunchIn = true;
            this.remainingTime = 250;
            try {
                const response = await axios.post(
                    route(`${this.routePrefix}punch-lunchClock`),
                    { empID: this.employeeInfo.ID, methodCall: "lunchIn" }
                );

                this.lunchInAlert = true;

                setTimeout(() => {
                    this.lunchInAlert = false;
                    this.exitLoggedInPage();
                    //this.loadingLunchIn = false;
                }, 3000);
            } catch (err) {
                console.error("Clock In Error:", err);
                this.loadingLunchIn = false;
            }
        },
        exitLoggedInPage() {
            //location.reload();
            let path = window.location.pathname;

            if (path === "/hr/ERP-Punch-hr-only") {
                return (window.location.href = route("hr.punch-system"));
            } else if (path === "/hr/ERP-Punch-home") {
                return (window.location.href = route("hr.punch-system-home"));
            } else {
                return (window.location.href = route("punch-system"));
            }
        },
    },
};
</script>

<style lang="css" scoped>
.digital-clock {
    font-size: 2.3rem;
    font-weight: bold;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
}

.digital-calander {
    font-size: 1.5rem;
    font-weight: bold;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
}

.login-page {
    background-image: url("/images/World-map.jpg");
    background-size: cover;
    background-position: center;
    height: 100vh;
}

.customize-table {
    --easy-table-header-font-size: 14px;
    --easy-table-header-font-color: #242939;
    --easy-table-header-background-color: #eee;
    --easy-table-header-font-color: #242939;

    --easy-table-body-row-height: 35px;
    --easy-table-body-row-font-size: 12px;

    --easy-table-body-row-hover-background-color: #eee;
}
</style>
